var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"color":"green darken-1","dark":""}},[_c('v-card-title',[_vm._v(_vm._s(_vm.title))]),_c('v-card-text',{staticClass:"text-h2 text-right"},[_vm._v(" "+_vm._s(_vm.formatValue(_vm.total))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }